function getAPI() {
  let baseUrl = "https://api.bilipatra.com/paymentms/"; /// Change this to your actual API URL
  // let baseUrl = "http://localhost:8085/paymentms/"; // Change this to your actual API URL

  // Page wise API call
  let dashboard = {
    displayDTDC: `${baseUrl}dtdc_courier_detail/v1/apiselection`,
    displayShreeNandan: `${baseUrl}shree_nandan_courier_detail/v1/apiselection`,
    displayShreeTirupati: `${baseUrl}shree_tirupati_courier_detail//v1/apiselection`,
    uploadexcel: `${baseUrl}order_excel_data/v1/processexcel`,
    getuploadedexceldata: `${baseUrl}order_excel_data/v1/apiselection`,
    unicommerceLogin: `${baseUrl}unicommerce_detail/login`,
    unicommerceGetOrderData: `${baseUrl}unicommerce_detail/searchorder`,
    unicommerceOrderList: `${baseUrl}unicommerce_detail/apiselection`,
    sendWhatsAppMessage: `${baseUrl}unicommerce_detail/sendWhatsapp`,
    getTrackingDataById: `${baseUrl}unicommerce_detail/gettrackings`,
    login: `${baseUrl}unicommerce_detail/elogin`,
    InquiryList: `${baseUrl}inquiry_detail/v1/getinquirylist`,
    RecourierList: `${baseUrl}inquiry_detail/v1/getrecouierlist`,
    RefundList: `${baseUrl}inquiry_detail/v1/getrefundlist`,
    ResolveList: `${baseUrl}inquiry_detail/v1/getinquirysolvedlist`,
    UpdateInquiryResolveStatus: `${baseUrl}inquiry_detail/v1/inquirysolved`,
    sendInquiryRecourier: `${baseUrl}inquiry_detail/v1/sendrecourier`,
    sendInquiryRefund: `${baseUrl}inquiry_detail/v1/sendrefund`,
    inquiryOrderList: `${baseUrl}inquiry_detail/v1/inquiryorderlist`,
    getmobileorderlist: `${baseUrl}inquiry_detail/v1/getmobile`,
    sendInquiryAttempt: `${baseUrl}inquiry_detail/v1/insertattempt`,
    getInquiryAttemptRemarkList: `${baseUrl}inquiry_detail/v1/getattemptremarks`,
    AttemptRemarkResolveList: `${baseUrl}inquiry_detail/v1/attemptresolved`,
    getAttemptInquiryList: `${baseUrl}inquiry_detail/v1/getattemptinquiry`,
    getCourierStatus: `${baseUrl}unicommerce_detail/getcourierstatus`,
    sendInquiryBulkMessage: `${baseUrl}inquiry_detail/v1/sendinquirybulkmessage`,
    getUndeliveredList: `${baseUrl}unicommerce_detail/undeliveredselection`,
    getInquirylog: `${baseUrl}inquiry_detail/v1/getinquirylog`,
    getCourierPartnerList: `${baseUrl}employee_detail/v1/getcourierpartner`,
    assignInquiry: `${baseUrl}inquiry_detail/v1/updateunquirylistbyassignto`,
    assignInquiryList: `${baseUrl}inquiry_detail/v1/getassignedinquirylist`,
    allTabSearch: `${baseUrl}inquiry_detail/v1/alltabsearch`,
    dashboardApi: `${baseUrl}BI_tool_dashboard/v1/apiorderlist`,
  };

  let master = {
    display: dashboard.displayDTDC,
    shree_nandan: dashboard.displayShreeNandan,
    shree_tirupati: dashboard.displayShreeTirupati,
    upload_excel: dashboard.uploadexcel,
    get_uploaded_data: dashboard.getuploadedexceldata,
    unicommerce_login: dashboard.unicommerceLogin,
    unicommerce_order_data: dashboard.unicommerceGetOrderData,
    unicommerce_order_list: dashboard.unicommerceOrderList,
    send_whatsapp_message: dashboard.sendWhatsAppMessage,
    getTrackingDataById: dashboard.getTrackingDataById,
    login: dashboard.login,
    InquiryList: dashboard.InquiryList,
    RecourierList: dashboard.RecourierList,
    RefundList: dashboard.RefundList,
    ResolveList: dashboard.ResolveList,
    UpdateInquiryResolveStatus: dashboard.UpdateInquiryResolveStatus,
    sendInquiryRecourier: dashboard.sendInquiryRecourier,
    sendInquiryRefund: dashboard.sendInquiryRefund,
    inquiryOrderList: dashboard.inquiryOrderList,
    getmobileorderlist: dashboard.getmobileorderlist,
    sendInquiryAttempt: dashboard.sendInquiryAttempt,
    getInquiryAttemptRemarkList: dashboard.getInquiryAttemptRemarkList,
    AttemptRemarkResolveList: dashboard.AttemptRemarkResolveList,
    getAttemptInquiryList: dashboard.getAttemptInquiryList,
    getCourierStatus: dashboard.getCourierStatus,
    sendInquiryBulkMessage: dashboard.sendInquiryBulkMessage,
    getUndeliveredList: dashboard.getUndeliveredList,
    getInquirylog: dashboard.getInquirylog,
    getCourierPartnerList: dashboard.getCourierPartnerList,
    assignInquiry: dashboard.assignInquiry,
    assignInquiryList: dashboard.assignInquiryList,
    allTabSearch: dashboard.allTabSearch,
    dashboardApi: dashboard.dashboardApi,
  };

  return {
    master,
  };
}

export default getAPI;
